

const state = {
    
    blocks:[
        {
            id:1,
            name: '',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Funktion/Anwendung",
                                size:"xs5",
                                invertedsize:"xs6",
                                displaytitle:"name",
                                displaysubtitle:"id",
                                multiple:true,
                                icon:"search",
                                variable: 'tag_ids',
                                setter: 'entities/ENTITY_SET_TAGS',
                                items:'tags/byFunction',
                                withdialog:true,
                            }                                    
                        }
                        
                    ], 
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Temperatur/Herstellung",
                                size:"xs5",
                                invertedsize:"xs6",
                                displaytitle:"name",
                                displaysubtitle:"id",
                                multiple:true,
                                icon:"search",
                                variable: 'tag_ids',
                                setter: 'entities/ENTITY_SET_TAGS',
                                items:'tags/byProduction',
                                withdialog:true,
                            }                                    
                        }
                        
                    ],      
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Saison/Region",
                                size:"xs5",
                                invertedsize:"xs6",
                                displaytitle:"name",
                                displaysubtitle:"id",
                                multiple:true,
                                icon:"search",
                                variable: 'tag_ids',
                                setter: 'entities/ENTITY_SET_TAGS',
                                items:'tags/bySeason',
                                withdialog:true,
                            }                                    
                        }
                        
                    ],      
                             
                ]
            },
        },
        {
            id:1,
            name: '',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Allergene/Alkohol",
                                size:"xs5",
                                invertedsize:"xs6",
                                displaytitle:"name",
                                displaysubtitle:"id",
                                multiple:true,
                                icon:"search",
                                variable: 'tag_ids',
                                setter: 'entities/ENTITY_SET_TAGS',
                                items:'tags/byAllergenics',
                                withdialog:true,
                            }                                    
                        }
                        
                    ], 
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Produktkategorie",
                                size:"xs5",
                                invertedsize:"xs6",
                                displaytitle:"name",
                                displaysubtitle:"id",
                                multiple:true,
                                icon:"search",
                                variable: 'tag_ids',
                                setter: 'entities/ENTITY_SET_TAGS',
                                items:'tags/byProduct',
                                withdialog:true,
                            }                                    
                        }
                        
                    ],      
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Sonstige",
                                size:"xs5",
                                invertedsize:"xs6",
                                displaytitle:"name",
                                displaysubtitle:"id",
                                multiple:true,
                                icon:"search",
                                variable: 'tag_ids',
                                setter: 'entities/ENTITY_SET_TAGS',
                                items:'tags/byOther',
                                withdialog:true,
                            }                                    
                        }
                        
                    ],      
                             
                ]
            },
        },
        {
            id:1,
            name: '',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formrecipesteptable',
                            attributes: {
                                placeholder:"Schritte",
                                size:"xs10",
                                invertedsize:"xs1",
                                variable: 'recipesteps',
                                setter: 'entities/ENTITY_SET_RECIPESTEPS',
                                items:'recipesteps/forrecipe',
                                withcheck:false,
                                withsearch:false,
                                withdialog:true,
                                
                            }                                        
                        },
                        
                    ],                   
                ]
            },
        },
        
    ]
    
};

export default {
  namespaced: false,
  state,
  
};